var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保险信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.insuranceInfo, function (item, i) {
    return _c("div", {
      key: i
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.insuranceInfoData[item.key]) || "-") + " ")])]);
  }), 0), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.insureInfo, function (item, i) {
    return _c("div", {
      key: i
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), item.key !== "occupation" && item.key !== "identificationType" ? _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.insureInfoData[item.key]) || "-") + " ")]) : _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.insureInfoData[item.key] || "-") + " ")])]);
  }), 0), _vm.insuranceInfoData.policyStatus == "退保中" || _vm.insuranceInfoData.policyStatus == "已退保" ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("退保信息")))])]) : _vm._e(), _vm.insuranceInfoData.policyStatus == "退保中" || _vm.insuranceInfoData.policyStatus == "已退保" ? _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.cancellationInfo, function (item, i) {
    return _c("div", {
      key: i
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(" " + _vm._s(_vm.insuranceInfoData.policyStatus == "退保中" && item.key == "rePremium" ? _vm.$t("应退保费") : _vm.$t(item.name)) + " ")]), _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.cancellationInfoData[item.key]) || "-") + " ")])]);
  }), 0) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };